import React, { FC, useState,useEffect } from 'react';
import Spinner from '../../Spinner/Spinner';
import { fetchPullRepositorys, fetchSearchRepositorys} from '../../../redux/slices/AdminRepositorysSlice'
import { useAppDispatch, useAppSelector} from '../../../redux/store/store';
import ModalAccess from '../Modal-Access/Modal-Access';
import ModalDelete from '../Modal-Deleted/Modal-Deleted';
import './ListAdminRepositories.css';
import { refreshToken } from '../../../refreshToken';

const ListAdminRepositories = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const result: { id: string, name: string, description: string, businessUnitId: string, filters: any[] }[] = useAppSelector(state => state.RepositorysSlice.result);
  const resultsearch: { id: string, name: string, description: string, businessUnitId: string, filters: any[] }[] = useAppSelector(state => state.RepositorysSlice.result);
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(2);
  useEffect(() => {
    refreshToken()
    setLoading(true)
    setTimeout(() => {
      dispatch(fetchPullRepositorys({ Page: page, Take: take }));
      setLoading(false)
    }, 1000);
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 1000);
  }, [take]);

const [repositoryName, setRepositoryName] = useState('');


const handlePageChange = (Page: number) => {

  setPage(Page);
  console.log("Este es el Page:", Page);
  dispatch(fetchPullRepositorys({ Page: page, Take: take }));
};
const handleTakeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
  event.preventDefault();
  setTake(Number(event.target.value));
  console.log("Este es el Take:", event.target.value)
  dispatch(fetchPullRepositorys({ Page: page, Take: take }));
}; 

  

 
  const handleOnBlur = () => {
    if(!repositoryName) {
      dispatch(fetchPullRepositorys({ Page: page, Take: take }));
    }
}
  const GetRepositoryByName = (repositoryName: any) => {
    console.log('GetRepositoryByName:', repositoryName);
    dispatch(fetchSearchRepositorys(repositoryName));
  }

  const handleKeyDown = (e:any) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      GetRepositoryByName(repositoryName);
    }
  };
    const paging = useAppSelector(state => state.RepositorysSlice.paging);
    console.log("este es el result search*****",resultsearch); 
    console.log("este es el result",result); 
  
return  loading ? <Spinner/>: (
   <div className="pds-dataTable pds-datatable-hoverable-rows">
  <div className="pds-dataTable-header">
    <p aria-hidden="true" className="pds-dataTable-title"></p>
    <div className="pds-searchInput pds-dataTable-smart-search" style={{maxWidth: 600, alignContent: 'left'}}>
    <input id="inputSearch" aria-label="" onChange={(e) => setRepositoryName(e.target.value)}  onBlur={handleOnBlur} onKeyDown={handleKeyDown} type="search" placeholder="Busqueda por nombre de repositorio"/>

<button type="submit" onClick={() => GetRepositoryByName(repositoryName)} aria-label="Search"></button>
    </div>
  </div>
  <div className="pds-dataTable-table-container pds-table-scrolling ">
    <table className="pds-table-container pds-table pds-table-bordered pds-table-hoverable-rows" id="pds-datatable-hoverable-rows-example" aria-live="polite">
      <caption className="sr-only">Title</caption>
      <thead>
        <tr>
          <th className="sort pds-dataTable-table-header text-center" scope="col" >Nombre del Repositorio</th>
          <th className="sort pds-dataTable-table-header text-center" scope="col" >Descripcion</th>
          <th className="sort pds-dataTable-table-header text-center"  scope="col"  colSpan={3}>Acciones</th>
        </tr>
      </thead>
      {Object.values(result).map((repository, index) => (
     <tbody className="tbody"> 
      <tr className="trBody" key={index}>
      <td className="td" >{repository.name} </td>
      <td className="td" ><span>{repository.description}</span></td>
      
      <td className="pds-tableActionMenu-actionColumn">
      <button className="pds-button pds-button-primary" disabled={true}>
    Eliminar</button>
      </td>
    </tr>
            </tbody>
             ))}
        </table>
  </div>
  <div className="pds-dataTable-footer">
        <div className="pds-dataTable-show-entries">
          <label className="pds-dataTable-select-label" />
          <div className="pds-select">
            <select
              id=""
              aria-label="Number of rows to display in table" name="entries" className="pds-dataTable-select-options pds-select-small"
              value={take}
              onChange={handleTakeChange}>
              <option value={2}>2</option>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
            </select>
          </div>
          <p className="pds-dataTable-total-entries" />
        </div>
        <nav
          aria-label="Pagination"
          className="pds-pagination pds-dataTable-pagination"
        >
          <span className="pds-dataTable-previous-buttons pds-dataTable-disable-pagination-buttons">
            <a
              role="link"
              tabIndex={0}
              aria-label="first page"
              aria-disabled={page === 1}
              className={`pds-dataTable-first-page pds-pagination-fly-first page ${page === 1 ? 'disabled' : ''
                }`}
              onClick={() => handlePageChange(1)}
            />
            <a
              role="link"
              tabIndex={0}
              aria-label="Previous page"
              aria-disabled={page === 1}
              className={`pds-dataTable-previous pds-pagination-step-forward page ${page === 1 ? 'disabled' : '' }`}
              onClick={() => handlePageChange(page - 1)} />
          </span>
          <ul className="pagination" />
          <span className="pds-dataTable-next-buttons">
            <a
              role="link"
              tabIndex={0}
              aria-label="Next page"
              className="pds-dataTable-next pds-pagination-step-backward page"
              onClick={() => handlePageChange(page + 1)}
            />
            <a
              role="link"
              tabIndex={0}
              aria-label="Last page"
              className="pds-dataTable-last-page pds-pagination-fly-last page"
              onClick={() => handlePageChange(page +1 )}
            />
          </span>
        </nav>
      </div>
    </div>

)}



export default ListAdminRepositories;